var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ue",class:_vm.isAuthPage},[_c('img',{attrs:{"src":require("@/assets/ue.jpg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }